import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=33588e06&scoped=true"
import script from "./AddContact.vue?vue&type=script&lang=ts"
export * from "./AddContact.vue?vue&type=script&lang=ts"
import style0 from "./AddContact.vue?vue&type=style&index=0&id=33588e06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33588e06",
  null
  
)

export default component.exports